import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormButton,
} from '@shared/components';

import {
  QuestionChangeInformationProvider,
  SingleQuestionChangeFormProvider,
} from '../../providers';
import { QuestionChangeInformationSection } from '../question-change-information-section';
import { SingleQuestionChangeTableSection } from '../single-question-change-table-section';

interface SingleQuestionChangeModalProps {
  questionId: string;
  qSetQuestionId: string;
  open: boolean;
  onClose: () => void;
  onComplete?: () => void;
}

export default function SingleQuestionChangeModal(props: Readonly<SingleQuestionChangeModalProps>) {
  const { questionId, qSetQuestionId, open: isOpen, onClose, onComplete } = props;

  const handleComplete = () => {
    onClose();
    onComplete?.();
  };

  return (
    <QuestionChangeInformationProvider>
      <Dialog open={isOpen} maxWidth='lg'>
        <SingleQuestionChangeFormProvider
          qSetQuestionId={qSetQuestionId}
          onComplete={handleComplete}
        >
          <DialogTitle onClose={onClose}>Change Question</DialogTitle>
          <Divider />

          <DialogContent
            sx={(theme) => ({ display: 'flex', flexDirection: 'column', gap: theme.spacing(4) })}
          >
            <QuestionChangeInformationSection questionId={questionId} />
            <SingleQuestionChangeTableSection />
          </DialogContent>
          <Divider />

          <DialogActions>
            <Button size='large' variant='outlined' color='secondary' onClick={onClose}>
              Cancel
            </Button>
            <FormButton label='Save' size='large' />
          </DialogActions>
        </SingleQuestionChangeFormProvider>
      </Dialog>
    </QuestionChangeInformationProvider>
  );
}
